<template>
  <atom-modal modalId="modal-discovery-credential">
    <template #header>
      <label class="header__topic">SNMP<span class="d-none">/WMI</span> Credentials</label>
      <label class="header__sub-topic"
        >Updating user details will receive a privacy audit.</label
      >
    </template>

    <template #body>
      <div class="body__container">
        <!-- SNMP -->
        <div class="body__snmp">
          <label class="body__snmp--topic">SNMP Community List</label>
        </div>

        <!-- SNMP List -->
        <div v-if="SNMPList.length" class="body__snmp--list">
          <div v-for="(snmp, index) in SNMPList" :key="index">
            <molecule-list-item-credential
              :id="snmp.credentialId"
              @delete="clickButtonDeleteSNMP"
            >
              <template #item>
                <label class="body__snmp--item">{{ snmp.snmpCommunity }}</label>
              </template>
            </molecule-list-item-credential>
          </div>
        </div>

        <!-- Add SNMP -->
        <div
          v-if="!isOpenSNMPCredential"
          class="body__add-credential box-dashed"
          @click="isOpenSNMPCredential = true"
        >
          <feather-icon
            class="icon-size-24px text-primary"
            icon="PlusCircleIcon"
          ></feather-icon>

          <label class="body__add-credential--text">Add SNMP Community</label>
        </div>
        <div v-if="isOpenSNMPCredential">
          <div class="body__add-snmp">
            <div class="body__add-snmp--container-input">
              <atom-input
                v-model="addSNMPName"
                placeholder="SNMP Name"
                :isError="isErrorSNMP"
                :errorMessage="errorMessageSNMP"
                class="body__add-snmp--input"
              >
              </atom-input>
            </div>

            <div class="body__add-snmp--button">
              <atom-button
                buttonId="add-snmp-credential"
                :isOnlyIcon="true"
                iconLeft="CheckIcon"
                :isDisable="isErrorSNMP && isValidateSNMP"
                class="body__add-snmp--button-check"
                @click="addSNMPCredential"
              ></atom-button>
              <atom-button
                buttonId="cancel-add-snmp-credential"
                :isOnlyIcon="true"
                iconLeft="XIcon"
                buttonStyle="border"
                buttonColor="secondary"
                class="body__add-snmp--button-x"
                @click="clearSNMPCredential"
              ></atom-button>
            </div>
          </div>
        </div>

        <!-- WMI -->
        <div class="body__wmi d-none">
          <label class="body__wmi--topic">WMI Credential List</label>
        </div>

        <!-- WMI List -->
        <div v-if="WMIList.length" class="body__wmi--list d-none">
          <div v-for="(wmi, index) in WMIList" :key="index">
            <molecule-list-item-credential
              :id="wmi.credentialId"
              @delete="clickButtonDeleteWMI"
            >
              <template #item>
                <div class="body__wmi--item w-100">
                  <div class="row w-100">
                    <div class="col-12 col-sm-4 body__wmi--item-username">
                      {{ wmi.username }}
                    </div>
                    <div class="col-12 col-sm-4 body__wmi--item-password">
                      {{ wmi.password }}
                    </div>
                    <div class="col-12 col-sm-4 body__wmi--item-ip-address">
                      {{ wmi.ipAddresses }}
                    </div>
                  </div>
                </div>
              </template>
            </molecule-list-item-credential>
          </div>
        </div>

        <!-- Add WMI -->
        <div
          v-if="!isOpenWMICredential"
          class="body__add-credential box-dashed d-none"
          @click="isOpenWMICredential = true"
        >
          <feather-icon
            class="icon-size-24px text-primary"
            icon="PlusCircleIcon"
          ></feather-icon>

          <label class="body__add-credential--text">Add WMI Credential</label>
        </div>
        <div v-if="isOpenWMICredential">
          <div class="body__add-wmi">
            <div class="body__add-wmi--container-input">
              <div class="body__add-wmi--sub-container-input">
                <atom-input
                  v-model="addWMI.username"
                  placeholder="Username"
                  :isError="isErrorWMIUsename && isValidateWMI"
                  class="body__add-wmi--input-inline-username"
                >
                </atom-input>
                <atom-input
                  v-model="addWMI.password"
                  placeholder="Password"
                  :isError="isErrorWMIPassword && isValidateWMI"
                  class="body__add-wmi--input-inline-password"
                >
                </atom-input>
              </div>
              <atom-input
                v-model="addWMI.ipAddresses"
                placeholder="101.0.0.1, 101.0.0.2"
                :isError="isErrorWMISubnet && isValidateWMI"
                class="body__add-wmi--input-full"
              >
              </atom-input>
              <div
                v-if="isErrorWMI && isValidateWMI"
                class="text-error"
                :class="{ 'margin-error': !isErrorWMISubnet }"
              >
                {{ errorMessageWMI }}
              </div>
            </div>

            <div class="body__add-wmi--button">
              <atom-button
                buttonId="add-wmi-credential"
                :isOnlyIcon="true"
                iconLeft="CheckIcon"
                :isDisable="isErrorWMI && isValidateWMI"
                class="body__add-wmi--button-check"
                @click="addWMICredential"
              ></atom-button>
              <atom-button
                buttonId="cancel-add-wmi-credential"
                :isOnlyIcon="true"
                iconLeft="XIcon"
                buttonStyle="border"
                buttonColor="secondary"
                class="body__add-wmi--button-x"
                @click="clearWMICredential"
              ></atom-button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </atom-modal>
</template>

<script>
import mixins from "@/mixins"
import AtomModal from "@/components/atoms/AtomModal.vue"
import AtomInput from "@/components/atoms/AtomInput.vue"
import AtomButton from "@/components/atoms/AtomButton.vue"
import MoleculeListItemCredential from "@/components/molecules/MoleculeListItemCredential.vue"
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue"

export default {
  name: "MoleculeModalDiscoveryCredential",
  components: {
    AtomModal,
    AtomInput,
    AtomButton,
    MoleculeListItemCredential,
    FeatherIcon,
  },
  mixins: [mixins],
  props: {
    modalId: {
      type: String,
      required: true,
    },
    SNMPList: {
      type: Array,
      required: false,
      default: null,
    },
    WMIList: {
      type: Array,
      required: false,
      default: null,
    },
  },
  emits: [
    "addCredentialsBySnmp",
    "addCredentialsByWmi",
    "deleteCredentialsBySnmp",
    "deleteCredentialsByWmi",
  ],
  data() {
    return {
      isOpenSNMPCredential: false,
      isOpenWMICredential: false,
      addSNMPName: "",
      addWMI: {
        username: "",
        password: "",
        ipAddresses: "",
      },
      isConfirmDelete: false,
      isValidateSNMP: false,
      isErrorSNMP: false,
      errorMessageSNMP: "",
      isValidateWMI: false,
      isErrorWMI: false,
      isErrorWMIUsename: false,
      isErrorWMIPassword: false,
      isErrorWMISubnet: false,
      errorMessageWMI: "",
    }
  },
  watch: {
    addSNMPName: {
      handler() {
        if (this.isOpenSNMPCredential && this.isValidateSNMP)
          this.validateSNMP()
      },
    },
    addWMI: {
      deep: true,
      handler() {
        if (this.isOpenWMICredential && this.isValidateWMI) this.validateWMI()
      },
    },
  },
  methods: {
    // click add
    addSNMPCredential() {
      this.isValidateSNMP = true
      this.validateSNMP()
      if (this.isValidateSNMP && !this.isErrorSNMP) {
        this.$emit("addCredentialsBySnmp", this.addSNMPName)
        this.setSNMPCredential()
        this.isValidateSNMP = false
      }
    },
    addWMICredential() {
      this.isValidateWMI = true
      this.validateWMI()
      if (this.isValidateWMI && !this.isErrorWMI) {
        this.$emit("addCredentialsByWmi", this.addWMI)
        this.setWMIPCredential()
        this.isValidateWMI = false
      }
    },

    // click X
    clearSNMPCredential() {
      this.isOpenSNMPCredential = false
      this.isValidateSNMP = false
      this.setSNMPCredential()
    },
    clearWMICredential() {
      this.isOpenWMICredential = false
      this.isValidateWMI = false
      this.setWMIPCredential()
    },

    // set credentials
    setSNMPCredential() {
      this.isOpenSNMPCredential = false
      this.addSNMPName = ""
      this.setErrorSNMP()
    },
    setErrorSNMP() {
      this.isErrorSNMP = false
      this.errorMessageSNMP = ""
    },
    setWMIPCredential() {
      this.isOpenWMICredential = false
      this.addWMI = {
        username: "",
        password: "",
        ipAddresses: "",
      }
      this.setErrorWMI()
    },
    setErrorWMI() {
      this.isErrorWMI = false
      this.isErrorWMIUsename = false
      this.isErrorWMIPassword = false
      this.isErrorWMISubnet = false
      this.errorMessageWMI = ""
    },

    // click delete
    clickButtonDeleteSNMP(credentialId) {
      this.$emit("deleteCredentialsBySnmp", credentialId)
    },
    clickButtonDeleteWMI(credentialId) {
      this.$emit("deleteCredentialsByWmi", credentialId)
    },

    // validate
    validateSNMP() {
      if (this.checkEmpty(this.addSNMPName)) {
        this.isErrorSNMP = true
        this.errorMessageSNMP = "Please enter SNMP name"
      } else this.setErrorSNMP()
    },
    validateWMI() {
      if (this.checkEmpty(this.addWMI.username)) this.isErrorWMIUsename = true
      else this.isErrorWMIUsename = false

      if (this.checkEmpty(this.addWMI.password)) this.isErrorWMIPassword = true
      else this.isErrorWMIPassword = false

      if (this.checkInvalidSubnet(this.addWMI.ipAddresses)) {
        this.isErrorWMISubnet = true
        if (this.isErrorWMIUsename || this.isErrorWMIPassword)
          this.errorMessageWMI =
            "Please enter valid username, password and subnet"
        else this.errorMessageWMI = "Please enter valid subnet"
      } else this.isErrorWMISubnet = false

      if (
        (this.isErrorWMIUsename || this.isErrorWMIPassword) &&
        !this.isErrorWMISubnet
      )
        this.errorMessageWMI = "Please enter valid username and password"

      if (
        this.isErrorWMIUsename ||
        this.isErrorWMIPassword ||
        this.isErrorWMISubnet
      )
        this.isErrorWMI = true
      else this.setErrorWMI()
    },
    checkEmpty(word) {
      return word === ""
    },
    checkInvalidSubnet(subnet) {
      const regEx =
        /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
      const ipAddresses = subnet.split(",")
      let isInvalid = false
      ipAddresses.forEach((ip) => {
        if (!regEx.test(ip.trim())) isInvalid = true
      })
      return isInvalid
    },
  },
}
</script>

<style lang="scss" scoped>
.header__topic {
  color: #5e5873;
  font-weight: 500;
  font-size: 22px;
  margin-top: 7px;
  margin-bottom: 0;
}
.header__sub-topic {
  color: #6e6b7b;
  font-weight: normal;
  font-size: 14px;
  margin-top: 14px;
  margin-bottom: 0;
}
.body__container {
  margin-top: 30px;
  padding: 0 16px 30px 0;
  width: 100%;
  height: 381px;
  overflow-y: auto;
}
// SNMP List
.body__snmp {
  width: 100%;
}
.body__snmp--topic {
  color: #5e5873;
  font-weight: 500;
  font-size: 18px;
  margin-bottom: 0;
}
.body__snmp--list {
  padding-top: 20px;
}
.body__snmp--item {
  overflow-wrap: break-word;
  width: 90%;
  font-weight: 600;
  font-size: 14px;
  color: #82868b;
}
// add SNMP
.body__add-snmp {
  margin-top: 20px;
}
.body__add-snmp--container-input {
  width: 100%;
}
.body__add-snmp--input {
  width: 100%;
}
.body__add-snmp--button {
  display: flex;
  justify-content: end;
  margin-top: 10px;
  height: 38px;
}
.body__add-snmp--button-check {
  margin-right: 10px;
}

// WMI
.body__wmi {
  width: 100%;
  margin-top: 80px;
}
.body__wmi--topic {
  color: #5e5873;
  font-weight: 500;
  font-size: 18px;
  margin-bottom: 0;
}
.body__wmi--list {
  padding-top: 20px;
}
.body__wmi--item {
  display: flex;
  font-weight: 600;
  font-size: 14px;
  color: #82868b;
}
.body__wmi--item-username,
.body__wmi--item-password {
  padding-right: 10px;
  overflow-wrap: break-word;
  margin-bottom: 10px;
}
.body__wmi--item-ip-adress {
  overflow-wrap: break-word;
}

// add WMI
.body__add-wmi {
  margin-top: 20px;
}
.body__add-wmi--container-input {
  width: 100%;
}
.body__add-wmi--sub-container-input {
  width: 100%;
  display: flex;
  margin-bottom: 10px;
}
.body__add-wmi--input {
  width: 100%;
  font-weight: 600;
  font-size: 14px;
  color: #82868b;
}
.body__add-wmi--input-inline-username {
  width: 50%;
  margin-right: 5px;
  font-weight: 600;
  font-size: 14px;
  color: #82868b;
}
.body__add-wmi--input-inline-password {
  width: 50%;
  margin-left: 5px;
  font-weight: 600;
  font-size: 14px;
  color: #82868b;
}
.body__add-wmi--button {
  display: flex;
  justify-content: end;
  margin-top: 10px;
}
.body__add-wmi--button-check {
  margin-right: 10px;
}

label {
  margin-bottom: 0;
}
.body__add-credential {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.body__add-credential--text {
  margin-left: 10px;
  margin-bottom: 0;
  color: #7367f0;
  font-weight: 600;
  font-size: 12px;
  cursor: pointer;
}
.box-dashed {
  height: 60px;
  border: 1px dashed rgba(115, 103, 240, 0.4);
  box-sizing: border-box;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 20px;
  &:hover {
    background-color: #f9f9fe;
  }
}

.text-error {
  color: #ea5455;
  font-size: 12px;
  line-height: 1.5;
}

.margin-error {
  margin-top: 4px;
}

// Small devices (landscape phones, 576px and up)
@media screen and (min-width: 576px) {
  .molecule-modal-discovery-credential__header--topic {
    font-size: 28px;
  }
  .molecule-modal-discovery-credential__header--subtopic {
    font-size: 14px;
  }
  .body__container {
    padding: 0 40px 30px 40px;
    height: 600px;
  }
  // add SNMP
  .body__add-snmp {
    display: flex;
    justify-content: space-between;
  }
  .body__add-snmp--container-input {
    width: 410px;
  }
  .body__add-snmp--button {
    display: flex;
    justify-content: end;
    margin-top: 0;
  }
  // add WMI
  .body__add-wmi {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }
  .body__wmi--item-username,
  .body__wmi--item-password {
    margin-bottom: 0;
  }
  .body__add-wmi--container-input {
    width: 410px;
  }
  .body__add-wmi--button {
    display: flex;
    justify-content: end;
    margin-top: 0;
  }
  .body__add-wmi--button-check {
    margin-right: 10px;
  }
}

// Medium devices (tablets, 768px and up)
@media screen and (min-width: 768px) {
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
}

// X-Large devices (large desktops, 1200px and up)
@media screen and (min-width: 1200px) {
}
</style>
